// src/Pages/Landing/JoyrideSeinajokiLanding.jsx
import React from "react";
import JoyrideKaupunkiLanding from "./JoyrideKaupunkiLanding.jsx";

export default function JoyrideSeinajokiLanding() {
  return (
    <JoyrideKaupunkiLanding
      city="Seinäjoki"
      maakunta="Etelä-Pohjanmaa"
      nearbyAreas={[
        "Lapua",
        "Kauhava",
        "Kurikka",
        "Ilmajoki",
        "Alavus",
        "Ähtäri"
      ]}
      cityText="Bilebändi Joyride tekee keikkoja Seinäjoella ja Etelä-Pohjanmaan alueella tapahtuman luonteesta, aikataulusta ja matkasta riippuen. Seinäjoki sopii Bilebändi Joyridelle hyvin esimerkiksi häihin, yritysjuhliin, pikkujouluihin, syntymäpäiville ja kesäjuhliin, kun juhliin halutaan energinen livebändi."
      logisticsText="Seinäjoen keikoissa kokonaisuus sovitaan aina tapahtumapaikan, aikataulun ja keikan keston mukaan. Bilebändi Joyridellä on oma kuljetus, oma äänentoisto ja valotekniikka, mikä helpottaa juhlan suunnittelua etenkin silloin, kun tapahtumapaikalla ei ole valmista tekniikkaa."
      bookingLink="/#varaa"
    />
  );
}